import { type FC, type PropsWithChildren } from 'react'

import { type LoginAfterLoggedIn } from '../../../login-registration/loginAfterLoggedIn'

import { LoginRegistrationLoginRenderSwitchExperiment } from './LoginRegistrationUserLoginRenderSwitchExperiment'

interface LoginRegistrationUserTwoStepLoginContentProps {
  afterLoggedIn: LoginAfterLoggedIn
}

export const LoginRegistrationUserTwoStepLoginContent: FC<
  PropsWithChildren<LoginRegistrationUserTwoStepLoginContentProps>
> = ({ afterLoggedIn, children }) => {
  return (
    <LoginRegistrationLoginRenderSwitchExperiment afterLoggedIn={afterLoggedIn}>
      {children}
    </LoginRegistrationLoginRenderSwitchExperiment>
  )
}
